import React from 'react'
import { FormattedMessage } from 'react-intl'

import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import RemoveIcon from 'assets/icons/remove-icon'

import {
  EcosystemHeaderIcon,
  EcosystemHeaderIconWrapper,
  EcosystemHeaderNavbarDivider,
  EcosystemHeaderNavbarHalfSide,
  EcosystemHeaderNavbarWrapper,
  EcosystemHeaderTitle
} from '../../Assessment/components/EcosystemData/style'
import { defaultThreatsOptions } from './Threats'
import { ThreatRemoveIconWrapper, ThreatToggleWrapper } from '../style'

const ThreatsContentHeader = ({ isOpen, item, handleOpenRemoveModal, toggleAccordion, disabled }) => {
  const threats = item.Level3ThreatId ? defaultThreatsOptions.level3Threats : defaultThreatsOptions.level2Threats
  const threatItemId = item.Level3ThreatId ? item.Level3ThreatId : item.Level2ThreatId
  const name = threats.find((element) => {
    return element.value === threatItemId
  })

  return (
    <>
      <EcosystemHeaderNavbarWrapper isOpen={isOpen} data-test="threats">
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <EcosystemHeaderIconWrapper>
            <EcosystemHeaderIcon />
          </EcosystemHeaderIconWrapper>
          <EcosystemHeaderTitle data-test="threats-name">{name? name.label : item.name}</EcosystemHeaderTitle>
        </EcosystemHeaderNavbarHalfSide>
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <ThreatToggleWrapper isActive={isOpen}>
            <FormattedMessage id= 'expand' />
            {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
          </ThreatToggleWrapper>
          {!disabled && (
            <>
              <EcosystemHeaderNavbarDivider />
              <ThreatRemoveIconWrapper
                delete={true}
                data-test="remove-button"
                onClick={(e) => {
                  e.stopPropagation()
                  handleOpenRemoveModal(item)
                }}
              >
                <RemoveIcon />
              </ThreatRemoveIconWrapper>
            </>
          )}
        </EcosystemHeaderNavbarHalfSide>
      </EcosystemHeaderNavbarWrapper>
    </>
  )
}

export default ThreatsContentHeader
